import Vue from 'vue'
import Vuex from 'vuex'

import { alert } from './alert.module'
import { account } from './account.module'
import { springReview } from './spring_review.module'
import { connection } from './connection.module'
import { client } from './client.module'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    connection,
    alert,
    account,
    springReview,
    client,
  },
})
